'use client';

import React, { useCallback, useEffect } from 'react';

type GumroadButtonProps = {
  productUrl: string;
  label?: string;
  className?: string;
};

export function GumroadButton({
  productUrl,
  label = 'Buy on Gumroad',
  className,
}: GumroadButtonProps) {
  useEffect(() => {
    if (document.querySelector('#gumroad-js')) return;
    const script = document.createElement('script');
    script.id = 'gumroad-js';
    script.src = 'https://gumroad.com/js/gumroad.js';
    script.async = true;
    document.body.append(script);
  }, []);

  const openCheckout = useCallback(() => {
    const hiddenLink = document.createElement('a');
    hiddenLink.href = productUrl.includes('?')
      ? `${productUrl}&wanted=true`
      : `${productUrl}?wanted=true`;
    hiddenLink.dataset.gumroadSingleProduct = 'true';
    hiddenLink.style.display = 'none';
    document.body.append(hiddenLink);
    hiddenLink.click();
    hiddenLink.remove();
  }, [productUrl]);

  return (
    <button
      type="button"
      onClick={openCheckout}
      className={
        className ??
        'bg-primary hover:bg-primary/90 rounded-lg px-6 py-3 font-medium text-white shadow transition hover:cursor-pointer'
      }
      aria-label={label}
      itemProp="url"
    >
      <span itemProp="name">{label}</span>
    </button>
  );
}
